<template>
  <div class="d-flex justify-center" :class="{ 'hide-scrollbar statusbar-mobile': $vuetify.breakpoint.xs }">
    <div
        v-for="(item, i) in steps"
        :key="i"
        class="d-flex align-center"
        :class="{ 'step-active font-bolder': currentStep === item.no }"
    >
      <div
          v-if="i !== 0"
          class="step-line"
          :class="{ 'step-passed': i < activeIndex() }"
          :style="{ 'min-width': (600 / steps.length) + 'px' }"
      ></div>
      <div class="step-item">
        <div class="flex-center outer-circle">
          <div class="flex-center inner-circle" :class="{ 'step-passed': i < activeIndex() }" @click="eventJump(item.no)">
            {{ item.no }}
          </div>
        </div>
        <div class="label-step max-w-[100px]" :style="labelStyled" @click="eventJump(item.no)">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusStep",
  props: {
    currentStep: {
      default: ""
    },
    steps: {
      default: () => []
    },
    labelStyled: {
      type: String,
      default: ""
    },
  },
  methods: {
    activeIndex () {
      let i = 0
      for (const x of this.steps) {
        if (typeof x.name === 'object' ? x.name.includes(this.currentStep) : this.currentStep === x.name) {
          return i
        }
        i++
      }
      return undefined
    },
    eventJump (stepNo) {
      this.$emit('onClick', stepNo)
    }
  }
}
</script>

<style scoped>
.step-line {
  height: 1px;
  background: var(--theme-color-nine);
}

.outer-circle {
  width: 80px;
  aspect-ratio: 1;
  border-radius: 100%;
  background: transparent;
}

.inner-circle {
  width: 42px;
  aspect-ratio: 1;
  border-radius: 100%;
  background: var(--theme-color-nine);
  color: #fff;
  font-size: 20px;
  font-family: var(--font-bold-type);
  cursor: pointer;
  user-select: none;
}

.step-item {
  position: relative;
  display: flex;
  justify-content: center;
}

.label-step {
  font-family: var(--font-bold-type);
  position: absolute;
  bottom: -26px;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  color: #000;
}


/* active */
.step-active .outer-circle {
  //box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
}
.step-active .inner-circle {
  background: linear-gradient(21.01deg, var(--theme-color-seven) 6.18%, #FBB040 84.83%);
  font-family: var(--font-bold-type);
}
.step-active .label-step {
  font-family: var(--font-bold-type);
}
.step-active .step-line {
  //background: #4C8FA6;
}

/* all steps before active step */
.step-passed {
  background: #4C8FA6;
}

.statusbar-mobile {
  min-height: 106px;
  width: 100%;
}
</style>